import { useEffect, useMemo, useState } from 'react';
import { LocalStorageWrapper, persistCache } from 'apollo3-cache-persist';

import { clientConfig } from '@/config/clientConfig';
import { useAuthStore } from '@/shared/store/auth.store';

import { getApolloClient } from '../apollo-client.service';
import { ApolloClientType } from '../types';

export function useApolloClient(): ApolloClientType {
  //todo refactor

  const authToken = useAuthStore((s) => s.accessToken);
  const [client, setClient] = useState(
    getApolloClient({
      authorizationHeader: authToken ?? undefined,
    }),
  );
  //костыльно обновил старницу чтоб стейт обновился ибо токена нет в хэдерах)
  useEffect(() => {
    (async (): Promise<void> => {
      if (clientConfig.api.isPersistCache) {
        await persistCache({
          cache: client.cache,
          storage: new LocalStorageWrapper(window.localStorage),
        });
      }

      setClient(
        getApolloClient({
          cache: client.cache,
          authorizationHeader: authToken ?? undefined,
        }),
      );
    })();
  }, [authToken]);

  return useMemo(() => {
    return getApolloClient({
      cache: client.cache,
      authorizationHeader: authToken ?? undefined,
    });
  }, [authToken]);

  // return client;
}
